import { Section } from '@/components/ui/layouts/sections/Section';
import { flexWrapper } from '@mage-ui/styled-system/recipes';
import { Instances } from '../Instances';

export const FiguresBlock = ({ data }) => {
  return (
    <Section
      heading={{
        title: data?.fields?.title,
        intro: data?.fields?.intro,
        epi: data?.fields?.epi,
      }}
    >
      <div
        className={flexWrapper({
          wrap: 'wrap',
          gap: 'gap300',
          gapM: 'gap700',
          direction: 'column',
          directionM: 'row',
        })}
      >
        <Instances instances={data?.relations?.FiguresList} />
      </div>
    </Section>
  );
};
